import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
Vue.use(Router)

// export default new Router({
//   routes,
//   mode: 'history' //本地测试
// })

export default new Router({
    base: '/',
    routes,
    mode: 'hash' //打包测试要改
}) 


// WEBPACK FOOTER //
// ./src/router/index.js